import React from "react";

const secondaryActionClassName =
    "inline-flex min-h-11 items-center justify-center rounded-xl border border-slate-200 bg-slate-50 px-4 py-2 text-sm font-medium text-slate-700 transition hover:border-primary/30 hover:bg-primary/5 hover:text-primary dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200";

const primaryActionClassName =
    "inline-flex min-h-11 items-center justify-center rounded-xl bg-primary px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-primary/90";

function LoadingIndicator() {
    return (
        <span className="h-4 w-4 rounded-full border-2 border-white/30 border-t-white animate-spin" />
    );
}

export default function ConsultationActionBar({
    patientName,
    patientGovId,
    consultationDateLabel,
    onOpenRecords,
    onOpenLastPrescription,
    onOpenDocuments,
    onSave,
    onFinish,
    loadingSubmit,
}) {
    return (
        <section className="rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-950">
            <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                    <div className="min-w-0">
                        <h2 className="truncate text-lg font-semibold text-slate-900 dark:text-white">
                            {patientName || "Paciente"}
                        </h2>
                        <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-slate-500 dark:text-slate-400">
                            <span>Fecha {consultationDateLabel || "--/--/----"}</span>
                            <span className="hidden text-slate-300 dark:text-slate-600 sm:inline">
                                |
                            </span>
                            <span>C.I. {patientGovId || "--"}</span>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 xl:flex xl:justify-end">
                        <button
                            type="button"
                            onClick={onSave}
                            disabled={loadingSubmit}
                            className={`${primaryActionClassName} disabled:cursor-not-allowed disabled:opacity-70`}
                        >
                            {loadingSubmit ? <LoadingIndicator /> : "Guardar"}
                        </button>
                        <button
                            type="button"
                            onClick={onFinish}
                            disabled={loadingSubmit}
                            className={`${primaryActionClassName} disabled:cursor-not-allowed disabled:opacity-70`}
                        >
                            {loadingSubmit ? <LoadingIndicator /> : "Guardar y finalizar"}
                        </button>
                    </div>
                </div>

                <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 xl:grid-cols-3">
                    <button
                        type="button"
                        onClick={onOpenRecords}
                        className={secondaryActionClassName}
                    >
                        Antecedentes
                    </button>
                    <button
                        type="button"
                        onClick={onOpenLastPrescription}
                        className={secondaryActionClassName}
                    >
                        Ult. graduacion
                    </button>
                    <button
                        type="button"
                        onClick={onOpenDocuments}
                        className={secondaryActionClassName}
                    >
                        Documentos
                    </button>
                </div>
            </div>
        </section>
    );
}
